import React from 'react';

const ServerErrors = props => {
    if (!props) {
        return null
    }

    const {
        serverErrors,
        resourcedTexts,
        onRemoveErrors
    } = props;

    return (
        <section className="server-errors">
            <p>{resourcedTexts.serverErrorsText}</p>
            <ul>
                {serverErrors.map(serverError => {
                    return <li dangerouslySetInnerHTML={{__html: serverError}} />
                })}
            </ul>

            <button type="button" className="server-errors__close" onClick={onRemoveErrors}>Close</button>
        </section>
    )
};

export default ServerErrors;